import React from 'react'
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function About() {
  return (
    <div className="mt-2">
        <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faUser} fontSize={128} className='mb-5 text-danger'/>
            <h2>About Us</h2>
            <p className='text-red'>Innovative solutions for businesses worldwide. Empower your digital vision with Milesoft.</p>
        </div>
        <div className='container'>
          <div className='card bg-light p-3'>
            <div className='card-body text-center'>
              <p>Milesoft is an innovative software development company from Malawi, offering customized solutions to businesses worldwide. With expert developers and a commitment to excellence, we help turn digital ideas into reality.</p>
              <a href='/services' className='btn btn-danger'>Our services</a>
            </div>
          </div>
        </div>
        <div className='container'>&nbsp;</div>
    </div>
  )
}

export default About